'use client'

import { env } from '@/env'
import { useRouteTracking } from 'analyzify-js/react'

import { isAnalyzifyEnabled } from './Analyzify.constants'

const RouteTracking = () => {
  useRouteTracking()

  return null
}

export const AnalyzifyRouteTracking = () => {
  if (!isAnalyzifyEnabled(env.NEXT_PUBLIC_ANALYZIFY_MODE)) return null

  return <RouteTracking />
}
